import AnswerButtonGroup from "@/components/train/AnswerButtonGroup";
export default {
  name: "FastMemoryRender",
  components: {
    AnswerButtonGroup
  },
  props: {
    difficulty: {
      type: Object,
      default: () => {
        return {
          playInterval: 1
        };
      }
    },
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  watch: {
    data() {
      this.init();
    }
  },
  data() {
    return {
      options: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      visible: 0
    };
  },
  methods: {
    showExample() {
      this.visible++;
      setTimeout(() => {
        this.visible++;
      }, this.difficulty.flashInterval * 1000);
    },
    onChoosed(l) {
      this.$emit('answer', l.length > 0 ? l.join(',') : null);
    },
    init() {
      this.visible = false;
    }
  },
  mounted() {
    this.init();
  }
};